import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Pet } from 'src/app/interfaces/pet';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { UserService } from 'src/app/services/user/user.service';
import { RegistrationProgressService } from 'src/app/services/registration-progress/registration-progress.service';
import { BannerDetails } from 'src/app/interfaces/user';
import { CloudinaryService } from 'src/app/services/cloudinary/cloudinary.service';
import { isPlatformBrowser } from '@angular/common';
import { ConfigService } from '../../../services/config/config.service';
import { FeatureFlagsService } from '../../../services/feature-flag/feature-flag.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public bannersDetails: BannerDetails[] = [];

  public displayUserIconDropdown: boolean = true;
  public displayNonAuthenticatedHeaderLinkNavBar: boolean = true;
  isBrowser: boolean;
  logoUrl = '';
  brandName = '';
  enabled = false;

  constructor(
    public authManager: AuthManagerService,
    private userService: UserService,
    private registrationProgressService: RegistrationProgressService,
    private router: Router,
    private cloudinaryService: CloudinaryService,
    private config: ConfigService,
    public featureFlags: FeatureFlagsService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.logoUrl = this.config.get('logo');
      this.brandName = this.config.get('displayName');

      this.enabled = this.featureFlags.isEnabled('enableBetaBanner');
    }

    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  get pets(): Pet[] {
    return this.userService.user ? this.userService.filterAliveRegisteredPets(this.userService.user.pets) : [];
  }

  get registrationFinished(): boolean {
    if (!this.userService.user) return true;
    const progress =
      this.registrationProgressService.getRegistrationProgressData(
        this.userService.user
      );
    return (
      progress.isFullNameRegistrationCompleted &&
      progress.isMembershipSelectionCompleted &&
      progress.isPetChipNumberRegistrationCompleted &&
      progress.isWelcomePackSelectCompleted
    );
  }

  get userEmail(): string | undefined {
    return this.userService.user?.contact?.email;
  }

  ngOnInit(): void {
    this.getBannerData();
  }

  opened(isOpened: boolean): void {
    if (this.isBrowser && isOpened) {
      window.analytics.track('header::menu::opened');
    }
  }

  getBannerData() {
    this.userService.getBannersDetails().subscribe({
      next: (details: BannerDetails[]) => {
        this.bannersDetails = details;
      },
      error: (error) => {
        console.error('Error fetching banner details', error);
      }
    });
  }

  public getPetImageUrl(petImageId: string): string {
    return this.cloudinaryService.getImageUrl(petImageId, 88, 88, null);
  }
}
